import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["inputTitle", "inputDescription", "titleCounter", "detailsCounter"]

  connect() {
    console.log("banner-connected")

    if (this.hasInputTitleTarget && this.hasTitleCounterTarget) {
      this.updateCounter(this.inputTitleTarget, this.titleCounterTarget)
    }

    if (this.hasInputDescriptionTarget && this.hasDetailsCounterTarget) {
      this.updateCounter(this.inputDescriptionTarget, this.detailsCounterTarget)
    }
  }

  updateCount(event) {
    const input = event.currentTarget

    if (input === this.inputTitleTarget) {
      this.updateCounter(input, this.titleCounterTarget)
    } else if (input === this.inputDescriptionTarget) {
      this.updateCounter(input, this.detailsCounterTarget)
    }
  }

  updateCounter(input, counter) {
    const limit = Number(input.dataset.bannerLimitsLimitValue) || 0
    const currentLength = input.value.length

    if (currentLength > limit) {
      input.value = input.value.slice(0, limit)
    }

    counter.textContent = `(${input.value.length} / ${limit})`

    if (input.value.length >= limit * 0.9) {
      counter.classList.add("text-danger")
    } else {
      counter.classList.remove("text-danger")
    }
  }
}
